import {
  PageContentAtom,
  PrimaryButtonAtom,
  ToolbarMolecule
} from '@justomx/atlas-components'
import LoaderAtom from 'components/atoms/Loader.atom'
import { useTestPrinter } from './TestPrinter.hook'

const TestPrinterPage = () => {
  const { actions, loading } = useTestPrinter()

  return (
    <>
      {loading && <LoaderAtom>Imprimiendo...</LoaderAtom>}

      <ToolbarMolecule
        title="Impresión de prueba"
        actionIcon="ic_arrow_back"
        onAction={actions.goBack}
      />

      <PageContentAtom>
        <PrimaryButtonAtom onClick={() => actions.printTest('A')}>
          Orientación por defecto
        </PrimaryButtonAtom>
        <PrimaryButtonAtom onClick={() => actions.printTest('B')}>
          Orientación rotada 90°
        </PrimaryButtonAtom>
        <PrimaryButtonAtom onClick={() => actions.printTest('C')}>
          Etiqueta actual armado
        </PrimaryButtonAtom>
      </PageContentAtom>
    </>
  )
}

export default TestPrinterPage
